export const validateScrollColor = (value) => {
  if (typeof value !== 'string') {
    return {
      isValid: false,
      message: `ComposedTable: "scrollColor" debe ser string. Valor recibido: ${typeof value}.`,
    };
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return {
      isValid: false,
      message: 'ComposedTable: "scrollColor" no puede ser un string vacío.',
    };
  }

  if (
    typeof window !== 'undefined' &&
    window.CSS?.supports &&
    !window.CSS.supports('color', trimmed)
  ) {
    return {
      isValid: false,
      message: `ComposedTable: "scrollColor" no es un color CSS válido. Valor recibido: "${value}".`,
    };
  }

  return { isValid: true, value: trimmed };
};
